import type { QueryClient } from '@tanstack/react-query';
import {
  attentionQueryRoot,
  bankQueryRoot,
  occurrenceQueryRoot,
  summaryQueryRoot,
} from '../../../../shared/api/index.js';
import { paymentQueries } from '../queries/payment-queries.js';

/**
 * Every write touches two places at once: the payment itself and the listings it belongs to. A
 * status change even moves it between listings, so the whole list branch goes, not one filter.
 *
 * The occurrence branch goes whole, without picking periods: saving, pausing, resuming and
 * cancelling all rewrite the periods of the payment inside the very same transaction (design note
 * D3), and which rows that touched is a decision taken on the server, not one this side can guess.
 */
export const invalidatePayment = async (queryClient: QueryClient, id: string): Promise<void> => {
  await Promise.all([
    queryClient.invalidateQueries({ queryKey: paymentQueries.lists() }),
    queryClient.invalidateQueries({ queryKey: paymentQueries.detail(id).queryKey }),
    queryClient.invalidateQueries({ queryKey: occurrenceQueryRoot.all() }),
    queryClient.invalidateQueries({ queryKey: summaryQueryRoot.all() }),
    queryClient.invalidateQueries({ queryKey: bankQueryRoot.all() }),
    queryClient.invalidateQueries({ queryKey: attentionQueryRoot.all(), refetchType: 'all' }),
  ]);
};
